import Vue from 'vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';

const recaptchaKey = process.env.VUE_APP_RECAPTCHA_KEY;

console.log('recaptchaKey', recaptchaKey);

Vue.use(VueReCaptcha, { siteKey: recaptchaKey });
